exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (width >= 64rem) {\n.instruction-block {\n    margin-left: 368px;\n}\n}\n", ""]);

// exports
